import { render, staticRenderFns } from "./formcheckbox.vue?vue&type=template&id=6655a2b4&"
import script from "./formcheckbox.vue?vue&type=script&lang=js&"
export * from "./formcheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports